export const allowedFileExtensions = [
    '3line',
    '7z',
    'aln',
    'bai',
    'bam',
    'bcf',
    'bed',
    'bin',
    'bz2',
    'cif',
    'ckpt',
    'cns',
    'counts',
    'crai',
    'cram',
    'csv',
    'ct',
    'dat',
    'docx',
    'eps',
    'fa',
    'fai',
    'fasta',
    'fastq',
    'feather',
    'fq',
    'fsa',
    'gff',
    'gff3',
    'gif',
    'gtf',
    'gz',
    'hmm',
    'ipynb',
    'jpeg',
    'jpg',
    'json',
    'log',
    'md',
    'mmcif',
    'mol2',
    'mzml',
    'npy',
    'npz',
    'parquet',
    'pdb',
    'pdbqt',
    'pdf',
    'pfs',
    'png',
    'pptx',
    'prism',
    'ps',
    'pth',
    'pzfx',
    'restraints',
    'safetensors',
    'sam',
    'sdf',
    'sra',
    'svg',
    'tar',
    'tgz',
    'txt',
    'vcf',
    'xlsx',
    'yml',
    'zip',
    'zst',
];

export function isoTimeStampToHumanReadable(timestamp: string) {
    const padLeft = (num: number): string => {
        if (num < 10) {
            return `0${num.toString()}`;
        }
        return num.toString();
    };
    const date = new Date(parseInt(timestamp, 10));
    const year = date.getFullYear();
    const month = padLeft(date.getMonth() + 1); // Add 1 as getMonth returns 0-indexed months
    const day = padLeft(date.getDate());
    const hours = padLeft(date.getHours());
    const minutes = padLeft(date.getMinutes());
    const seconds = padLeft(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
